import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  verificationStatus: false,
};

const verificationSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {
    setVerificationStatus: (state, action) => {
      state.verificationStatus = action.payload;
    },
  },
});

export const { setVerificationStatus } = verificationSlice.actions;

export default verificationSlice.reducer;
